import { profileQuestionInit } from "./question"
import { profileFormInit } from "./profileform"
import { paymentFormInit } from "./payment"
import { payFormInit } from "./payform"

export const profileInit = () => {
  profileQuestionInit()
  profileFormInit()
  paymentFormInit()
  payFormInit()
}
